<div class="form_to_fill_content">
  <p class='padded-content' [innerHTML]="'home.annualDeclaration' | translate"></p>
  @if (
    !!(this.menuItems.mainMenuItems$ | async)) {
    @if (!isMemberCompanyRegisterForCurrentPeriod) {
      <div
        class="information_notice"
        >
        <p
        [innerHTML]="
          'home.memberNotRegisterForCurrentPeriod' | translate
        "
        ></p>
      </div>
    }
    @if (isMemberCompanyRegisterForCurrentPeriod) {
      <div>
        @if (hasFormEditable) {
          <div
            class='legal-entity-generic-button-container'
            >
            <button
              mat-flat-button
              [routerLink]="['/', 'company']"
              color="primary"
              class="home-fill-form-button">
              {{ "legalEntity.title" | translate }}
            </button>
          </div>
        }
        @if (!hasFormEditable) {
          <div class='legal-entity-card-container'
            >
            @for (legalEntity of legalEntities; track legalEntity) {
              <odq-form-state
                [legalEntity]="legalEntity"
              ></odq-form-state>
            }
          </div>
        }
      </div>
    }
  } @else {
    <div class="loading-spinner">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  }
</div>

